import { render, staticRenderFns } from "./fedex.vue?vue&type=template&id=59c25193&scoped=true"
import script from "./fedex.vue?vue&type=script&lang=js"
export * from "./fedex.vue?vue&type=script&lang=js"
import style0 from "./fedex.vue?vue&type=style&index=0&id=59c25193&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c25193",
  null
  
)

export default component.exports